import React from 'react'
import { Link } from 'gatsby'

import './MenuItems.scss'
import Arrow from '../../Assets/arrow.svg'

function MenuItems(props) {

    //props.item.name is like curry, verdura, etc..
    //i want to return Curry, Verdura, etc..
    // and if i have yakisoba classico, i want to return YakisobaClassico

    let link = props.item.name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')

    return (
        <Link 
            className='banzai_menu_item' 
            onClick={props.closeMenu} 
            to={`/${link == "Prossimamente..." ? "" : link}`}
        >
            <div className='banzai_menu_item__info'>
                <img src={props.item.img} alt={props.item.name} />
                <span className='banzai_menu_item__info__span'>{props.item.name}</span>
            </div>
            <img src={Arrow} className='arrow_menu' alt='arrow' />
        </Link>
    )
}

export default MenuItems